export default __webpack_public_path__ + "static/savings-type-website-d4228cf0c9bc6ef237b94a4159a12ae3.png";